module.exports = __webpack_public_path__ + "media/images/crypto/bitcoin-8e1bc77f80751a83a9852f463d6cd97c.png";